export enum ChatTypeEnum {
    // EzeMart
    EzeMartOrder = 1,
    CustomerSupport = 2,
    MerchantSupport = 3,

    // Xpress
    XpressOrder = 4
}
